import isEmpty from 'lodash/isEmpty'
import { Entry } from 'contentful'
import { GenericContentBlock } from 'types/contentful/genericContentBlock'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { TDesignJourneyWithArtwork } from '../../../_types'
import {
  EditorContentfulConfiguration,
  TDesignChatbotConfigFields,
} from '../../designUpload/types'
import { IDesignerChatbot } from '../../DesignerChatbot'
import { IPlusEditorContentfulConfiguration } from 'app/(main)/(catalog)/quote/[slug]/_types'

export type TDesignChatBotUseCases =
  | TDesignJourneyWithArtwork
  | 'editorNoteOnFilesTypes'
  | 'editorNoteOnTrial'

const mapChatbotUseCaseToConfig: Record<
  TDesignChatBotUseCases,
  TDesignChatbotConfigFields
> = {
  briefing: 'briefingFormDesignerChatbot',
  upload: 'designUploadDesignerChatbot',
  editor: 'onlineEditorDesignerChatbot',
  editorNoteOnFilesTypes: 'filesIncompatibilitiesDesignerChatbot',
  editorNoteOnTrial: 'editorTrialingNoteDesignerChatbot',
}

const parseDesignerChatbotConfiguration = (
  contentfulDesignChatbotConfiguration: Entry<GenericContentBlock>
): IDesignerChatbot => {
  if (isEmpty(contentfulDesignChatbotConfiguration)) {
    return null
  }

  return {
    text: contentfulDesignChatbotConfiguration?.fields?.h1,
    image: mapContentfulImageAsset(
      contentfulDesignChatbotConfiguration?.fields?.primaryImages?.[0]
    ),
  }
}

const getDesignerChatbotConfigs = (
  editorConfiguration: EditorContentfulConfiguration
): Record<TDesignChatBotUseCases, IDesignerChatbot> => {
  const designerChatBotsConfig: Record<
    TDesignChatBotUseCases,
    IDesignerChatbot
  > = {
    editor: null,
    briefing: null,
    upload: null,
    editorNoteOnFilesTypes: null,
    editorNoteOnTrial: null,
  }

  Object.keys(designerChatBotsConfig).forEach((useCaseKey) => {
    const chatBotConfig =
      editorConfiguration[mapChatbotUseCaseToConfig[useCaseKey]]
    designerChatBotsConfig[useCaseKey] =
      parseDesignerChatbotConfiguration(chatBotConfig)
  })

  return designerChatBotsConfig
}

export { parseDesignerChatbotConfiguration, getDesignerChatbotConfigs }
